import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioExtensionAccommodationEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioExtensionAccommodationEntity
